import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import EmptyState from 'components/EmptyState';
import PanelSection from 'components/PanelSection';
import Skeleton from 'components/loaders/Skeleton';

import { SKELETON_ROW_COUNT, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const skeletonKeys = Array.from({ length: SKELETON_ROW_COUNT }, (_, index) => `skeleton-${index}`);

const OrgFieldPickerColumn: FunctionComponent<Props> = ({
    emptyMessage,
    headerText,
    isLoading,
    items,
    onItemClick,
    promptMessage,
    rowTestId,
    selectedItemId,
    showPrompt = false,
    testId = TEST_ID
}) => {
    const hasItems = items.length > 0;
    const showLoading = !showPrompt && isLoading;
    const showEmpty = !showPrompt && !isLoading && !hasItems;
    const showList = !showPrompt && !isLoading && hasItems;

    return (
        <PanelSection className={styles.column} testId={testId} text={headerText}>
            {showPrompt && promptMessage && <EmptyState text={promptMessage} />}

            {showLoading &&
                skeletonKeys.map(key => <Skeleton className={styles.skeletonRow} key={key} />)}

            {showEmpty && <EmptyState text={emptyMessage} />}

            {showList && (
                <VerticalContainer className={styles.list}>
                    {items.map(item => {
                        const isSelected = item.id === selectedItemId;
                        const selectedClass = isSelected ? styles.rowSelected : '';
                        const handleItemClick = () => onItemClick(item.id);

                        return (
                            <HorizontalContainer
                                className={`${styles.row} ${selectedClass}`}
                                key={item.id}
                                onClick={handleItemClick}
                                testId={rowTestId}>
                                <Wrapper className={styles.rowLabel}>{item.name}</Wrapper>
                            </HorizontalContainer>
                        );
                    })}
                </VerticalContainer>
            )}
        </PanelSection>
    );
};

export default OrgFieldPickerColumn;
